import React from 'react';
import './feed.css';

function FeedbackItem({ feedback }) {
  return (
    <>
      <div className="feedback_container">
        <div className="feedback__company">
          <div className="feedback__company_logo pointer-all">
            <svg
              width="96"
              height="111"
              viewBox="0 0 96 111"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask id="path-1-inside-1_196_488" fill="white">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M89.5489 24.2811C74.6501 21.2094 60.5114 15.3183 47.972 6.93363C35.4377 15.3006 21.3019 21.2057 6.40124 24.2807L6.40124 41.4702C6.40124 68.3509 22.5744 92.8599 47.9751 104.318C73.3757 92.8599 89.5489 68.3509 89.5489 41.4702V24.2811ZM47.9751 110.529C76.6661 98.6711 95.2509 71.5175 95.2509 41.4702V19.5384C78.1357 16.7317 61.9476 10.0521 48.0429 0.0435154L47.9751 0L47.9072 0.0435154C34.0026 10.0303 17.8144 16.7317 0.699219 19.5384L0.699219 41.4702C0.699219 71.5175 19.284 98.6711 47.9751 110.529Z"
                />
              </mask>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M89.5489 24.2811C74.6501 21.2094 60.5114 15.3183 47.972 6.93363C35.4377 15.3006 21.3019 21.2057 6.40124 24.2807L6.40124 41.4702C6.40124 68.3509 22.5744 92.8599 47.9751 104.318C73.3757 92.8599 89.5489 68.3509 89.5489 41.4702V24.2811ZM47.9751 110.529C76.6661 98.6711 95.2509 71.5175 95.2509 41.4702V19.5384C78.1357 16.7317 61.9476 10.0521 48.0429 0.0435154L47.9751 0L47.9072 0.0435154C34.0026 10.0303 17.8144 16.7317 0.699219 19.5384L0.699219 41.4702C0.699219 71.5175 19.284 98.6711 47.9751 110.529Z"
                fill="white"
              />
              <path
                d="M47.972 6.93363L51.6198 1.47834L47.9751 -0.958718L44.3285 1.47546L47.972 6.93363ZM89.5489 24.2811H96.1114V18.9336L90.874 17.8538L89.5489 24.2811ZM6.40124 24.2807L5.07495 17.8536L-0.161255 18.9341L-0.161255 24.2807H6.40124ZM47.9751 104.318L45.2765 110.3L47.9751 111.518L50.6736 110.3L47.9751 104.318ZM47.9751 110.529L45.4684 116.594L47.9751 117.63L50.4817 116.594L47.9751 110.529ZM95.2509 19.5384L101.813 19.5384V13.9644L96.3129 13.0624L95.2509 19.5384ZM48.0429 0.0435154L51.8767 -5.28269L51.7343 -5.3852L51.5866 -5.47996L48.0429 0.0435154ZM47.9751 0L51.5187 -5.52347L47.9752 -7.79689L44.4316 -5.5236L47.9751 0ZM47.9072 0.0435154L44.3638 -5.48008L44.2188 -5.3871L44.0789 -5.28664L47.9072 0.0435154ZM0.699219 19.5384L-0.36279 13.0624L-5.86328 13.9644V19.5384H0.699219ZM44.3242 12.3889C57.5767 21.2505 72.5057 27.4678 88.2238 30.7084L90.874 17.8538C76.7944 14.951 63.4461 9.38624 51.6198 1.47834L44.3242 12.3889ZM7.72754 30.7077C23.4503 27.4632 38.3737 21.231 51.6154 12.3918L44.3285 1.47546C32.5017 9.37015 19.1536 14.9483 5.07495 17.8536L7.72754 30.7077ZM12.9637 41.4702V24.2807H-0.161255L-0.161255 41.4702H12.9637ZM50.6736 98.3364C27.5236 87.8932 12.9637 65.6613 12.9637 41.4702H-0.161255C-0.161255 71.0405 17.6253 97.8266 45.2765 110.3L50.6736 98.3364ZM82.9864 41.4702C82.9864 65.6613 68.4266 87.8932 45.2765 98.3364L50.6736 110.3C78.3248 97.8266 96.1114 71.0405 96.1114 41.4702H82.9864ZM82.9864 24.2811V41.4702H96.1114V24.2811H82.9864ZM88.6884 41.4702C88.6884 68.7483 71.811 93.5769 45.4684 104.464L50.4817 116.594C81.5213 103.765 101.813 74.2868 101.813 41.4702H88.6884ZM88.6884 19.5384V41.4702H101.813V19.5384L88.6884 19.5384ZM44.2091 5.36972C58.9486 15.9792 76.0882 23.046 94.1889 26.0144L96.3129 13.0624C80.1833 10.4173 64.9465 4.12495 51.8767 -5.28269L44.2091 5.36972ZM44.4314 5.52347L44.4992 5.56699L51.5866 -5.47996L51.5187 -5.52347L44.4314 5.52347ZM51.4507 5.56711L51.5185 5.5236L44.4316 -5.5236L44.3638 -5.48008L51.4507 5.56711ZM1.76123 26.0144C19.8669 23.0452 37.0032 15.9549 51.7355 5.37367L44.0789 -5.28664C31.002 4.10565 15.7619 10.4181 -0.36279 13.0624L1.76123 26.0144ZM7.26172 41.4702L7.26172 19.5384H-5.86328L-5.86328 41.4702H7.26172ZM50.4817 104.464C24.1392 93.5769 7.26172 68.7483 7.26172 41.4702H-5.86328C-5.86328 74.2868 14.4288 103.765 45.4684 116.594L50.4817 104.464Z"
                fill="white"
                mask="url(#path-1-inside-1_196_488)"
              />
              <path
                d="M23.5098 31.3612H54.2177L52.0118 38.006H25.5112L23.5098 31.3612Z"
                fill="white"
              />
              <path
                d="M25.5742 39.1863H32.48V62.7635L25.5742 65.3608L25.5742 39.1863Z"
                fill="white"
              />
              <path d="M31.4648 46.4045H41.7008L39.3038 53.0493H31.4648V46.4045Z" fill="white" />
              <path
                d="M46.0184 46.4652H71.1702L68.9396 53.11H43.5996L46.0184 46.4652Z"
                fill="white"
              />
              <path
                d="M46.0184 69.6373H71.1702L68.9396 76.2821H43.5996L46.0184 69.6373Z"
                fill="white"
              />
              <path
                d="M43.6289 54.2893H52.8483L71.1469 68.4559H61.314L43.6289 54.2893Z"
                fill="white"
              />
            </svg>
            <h2>FATALITY</h2>
          </div>
          <div className="feedback__company_text">
            <p className="paragraph pointer-all">{feedback.description}</p>
          </div>
        </div>
        <div className="feedback__letter">
          <img src={feedback.photo} alt="feedback" loading="lazy" />
        </div>
      </div>
    </>
  );
}

export default FeedbackItem;
